import { FETCH_SKIPPED_ENROLLMENT_LIST } from 'automation-ui-canvas/containers/enrollment-history/panel/queries/skippedEnrollmentQueries';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getTimestampsFromHistoryFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { useQuery } from 'data-fetching-client';
export const useSkippedEnrollmentsList = ({
  flowId,
  objectTypeId,
  hybrid,
  skip
}) => {
  const {
    filters
  } = useApplicationHistoryFilters();
  const timeStamps = getTimestampsFromHistoryFilters(filters);
  const variables = Object.assign({
    flowId,
    isHybrid: hybrid,
    startTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp,
    endTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.endTimestamp,
    objectTypeId,
    objectId: filters.getObjectId()
  }, filters.getObjectId() && objectTypeId ? {
    objectFilter: {
      objectTypeId,
      objectIds: [filters.getObjectId()]
    }
  } : {});
  return useQuery(FETCH_SKIPPED_ENROLLMENT_LIST, {
    variables,
    notifyOnNetworkStatusChange: true,
    skip: skip || !timeStamps || !(timeStamps !== null && timeStamps !== void 0 && timeStamps.startTimestamp) || !!(timeStamps !== null && timeStamps !== void 0 && timeStamps.endTimestamp) && timeStamps.startTimestamp > timeStamps.endTimestamp
  });
};